import type {FC} from 'react';
import {useGetIdentity} from 'react-admin';
import {ADMIN_COMPANIES} from '@/domain/entities/User';

const Dashboard: FC = () => {
  const {identity, isPending} = useGetIdentity();
  if (isPending || !identity) {
    return null;
  }
  const organization = identity.organization;
  if (!organization || !ADMIN_COMPANIES.includes(organization)) {
    window.location.href = '/404';
  }
  return null;
};

export default Dashboard;
